export const getDeltaProps = delta => {
  const isNA = isNaN(delta);
  const isNegative = delta < 0;
  const isPositive = delta > 0;
  const isZero = delta === 0;
  const absValue = Math.abs(delta);

  return { isPositive, isNegative, isZero, absValue, isNA };
};
